import { authRoles } from 'app/auth';
import i18next from 'i18next';
import enNavigation from './navigation-i18n/en';
import huNavigation from './navigation-i18n/hu';

i18next.addResourceBundle('en', 'navigation', enNavigation);
i18next.addResourceBundle('hu', 'navigation', huNavigation);

const navigationConfig = [
  {
    id: 'operator',
    title: 'OPERATOR',
    translate: 'OPERATOR',
    type: 'group',
    icon: 'apps',
    // "user" role -> only this group should be visible
    auth: authRoles.operator,
    children: [
      {
        id: 'device',
        title: 'Device',
        type: 'item',
        icon: 'developer_board',
        url: '/device',
        auth: authRoles.operator
      },
      {
        id: 'measurement',
        title: 'Data Store',
        type: 'item',
        icon: 'speed',
        url: '/measurement',
        auth: authRoles.operator
      },
      {
        id: 'prediction-device',
        title: 'Prediction Device',
        type: 'item',
        icon: 'online_prediction',
        url: '/prediction-device',
        auth: authRoles.predictionDevice
      }
    ]
  },
  {
    id: 'administrative',
    title: 'ADMINISTRATIVE',
    translate: 'ADMINISTRATIVE',
    type: 'group',
    icon: 'apps',
    // "admin" role -> everything (including this group)
    auth: authRoles.admin,
    children: [
      {
        id: 'project',
        title: 'Project',
        type: 'item',
        icon: 'build',
        url: '/project',
        auth: authRoles.admin
      },
      {
        id: 'device-type',
        title: 'Device Type',
        type: 'item',
        icon: 'device_hub',
        url: '/device-type',
        auth: authRoles.admin
      },
      {
        id: 'sensor-type',
        title: 'Sensor Type',
        type: 'item',
        icon: 'device_hub',
        url: '/sensor-type',
        auth: authRoles.admin
      },
      {
        id: 'prediction-type',
        title: 'Prediction Type',
        type: 'item',
        icon: 'settings_input_component',
        url: '/prediction-type',
        auth: authRoles.predictionType
      },
      {
        id: 'user-list',
        title: 'Hozzáférés',
        translate: 'USER_LIST',
        type: 'item',
        icon: 'person',
        url: '/user',
        auth: authRoles.admin
      }
    ]
  }
];

export default navigationConfig;
